<template>
  <div v-if="!!phaseData">
    <div>
      <h1 class="hypothesis-title">Hipótese diagnóstica: {{ hypothesis().value }}</h1>
    </div>
    <div class="mt-4">
      <p class="hypothesis-text">{{ hypothesis().info }}</p>
    </div>
  </div>
</template>
<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  extends: BasePhase,
  data() {
    return {}
  },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey']),
    diagnosisPhaseData() {
      return this.getPhaseDataByKey('diagnostico')
    },
  },
  methods: {
    getDefaultData() {
      const data = {
        value: null,
      }
      return data
    },
    hypothesis() {
      const diagnosis = this.diagnosisPhaseData
      if (diagnosis?.doenca_auto_inflamatoria) {
        this.phaseData.value = 'DAI Hereditária/Adquirida'
        return {
          value: 'DAI Hereditária/Adquirida',
          info: 'Esse sistema foi desenvolvido para auxílio do fluxo de investigação diagnóstica baseado no "The international EAACI/GAÇLEN/EuroGuiDerm/APAAACI guideline" e conforme a ANVISA e bula de cada um dos medicamentos e tratamento da UCE. Para investigação complementar, diferenciais e dúvidas terapêuticas, está disponível a função de interconsulta para conversar com um especialista Dermatologista, Reumatologista ou Imunologista.',
        }
      }
      if (diagnosis?.vasculite_biopsia) {
        this.phaseData.value = 'Urticária Vasculite'
        return {
          value: 'Urticária Vasculite',
          info: 'Essa doença pode clinicamente se assemelhar a urticária com pápulas avermelhadas semelhantes às urticas que entretanto não são fugazes e podem deixar manchas acastanhadas no local. Classicamente é uma vasculite leucocitoclástica e não está associada à histamina.\nSinais mínimos de vasculite na histopatologia podem ocorrer também em pacientes com urticária crônica. A presença de hipocomplementemia pode ocorrer e está eventualmente associada à doença mais severa.',
        }
      }
      if (diagnosis?.sintomas_induziveis.value === 'NAO' || diagnosis?.teste_provocacao === false) {
        if (this.$moment().diff(diagnosis.data_sintomas, 'weeks') > 6) {
          this.phaseData.value = 'Urticária Crônica Espontânea'
          return {
            value: 'Urticária Crônica Espontânea',
            info: 'Esse sistema foi desenvolvido para auxílio do fluxo de investigação diagnóstica baseado no "The international EAACI/GAÇLEN/EuroGuiDerm/APAAACI guideline" e conforme a ANVISA e bula de cada um dos medicamentos e tratamento da UCE. Somente doses on-label estão aqui sugeridas. Condutas divergentes poderão ser tomadas sob responsabilidade do médico prescritor.\n\nA seguir, escolha em qual STEP de tratamento seu paciente se encontra atualmente.',
          }
        } else {
          this.phaseData.value = 'Urticária Aguda'
          return {
            value: 'Urticária Aguda',
            info: 'Seu caso apresenta sintomas compatíveis com urticária aguda e deve ser tratado com anti-histamínicos, remoção do agente causal, eventualmente corticoterapia sistêmica por tempo limitado. Caso os sintomas persistam no total por mais de 6 semanas, o diagnóstico de UCE pode ser possível.',
          }
        }
      }
      if (diagnosis?.teste_provocacao) {
        this.phaseData.value = 'Urticária Crônica Induzida'
        return {
          value: 'Urticária Crônica Induzida',
          info: 'Esse sistema foi desenvolvido para auxílio do fluxo de investigação diagnóstica baseado no "The international EAACI/GAÇLEN/EuroGuiDerm/APAAACI guideline" e conforme a ANVISA e bula de cada um dos medicamentos e tratamento da UCE.  Alguns casos podem ter sobreposição de urticária vasculite e UCE ou Urticaria induzida e UCE. Converse com um especialista sobre seu caso.',
        }
      }
      if (diagnosis?.angioedema_deficiencia_c1) {
        this.phaseData.value = 'AEH/AEA'
        return {
          value: 'AEH/AEA',
          info: 'Esse sistema foi desenvolvido para auxílio do fluxo de investigação diagnóstica baseado no "The international EAACI/GAÇLEN/EuroGuiDerm/APAAACI guideline" e conforme a ANVISA e bula de cada um dos medicamentos e tratamento da UCE. Para investigação complementar, diferenciais e dúvidas terapêuticas, está disponível a função de interconsulta para conversar com um especialista Dermatologista, Reumatologista ou Imunologista.',
        }
      }
      if (diagnosis?.melhora_parar_ieca) {
        this.phaseData.value = 'AE induzido por i-ECA'
        return {
          value: 'AE induzido por i-ECA',
          info: 'Esse sistema foi desenvolvido para auxílio do fluxo de investigação diagnóstica baseado no "The international EAACI/GAÇLEN/EuroGuiDerm/APAAACI guideline" e conforme a ANVISA e bula de cada um dos medicamentos e tratamento da UCE. Para investigação complementar, diferenciais e dúvidas terapêuticas, está disponível a função de interconsulta para conversar com um especialista Dermatologista, Reumatologista ou Imunologista.',
        }
      }
      return {
        value: 'Sem informações suficientes.',
        info: 'Complete a fase de diagnóstico para receber uma hipótese.',
      }
    },
  },
}
</script>

<style scoped>
.hypothesis-title {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #1976d2;
}
.hypothesis-text {
  white-space: pre-line;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #000000;
}
</style>
